module.exports = __webpack_public_path__ + "img/job-manual.c2114d0d.svg";